import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { ApiUrlService } from '@pryspace/shared/environments';
import { TenantMe } from './models';

/**
 * Per-tenant "me" — what permissions/groups does the calling user have in
 * the addressed tenant. Backed by
 * `GET /v1/tenants/<slug>/me/`.
 */
@Injectable({ providedIn: 'root' })
export class TenantService {
  private http = inject(HttpClient);
  private api = inject(ApiUrlService);

  me(slug: string) {
    return firstValueFrom(
      this.http.get<TenantMe>(this.api.url(`v1/tenants/${slug}/me/`)),
    );
  }
}
